import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import "../../utils/Style/component/modals.scss";
import { setShowDeleteEmployeePopup, setShowEmployeeDetailsPopup } from '../../features/employeeSlice';
import useEmployeesApi from '../../api/EmployeesApi';
import { setActionPayload, setActionType } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { useOutletContext } from 'react-router-dom';

function DeleteEmployeePopup() {
    const employeeDetails = useSelector(state => state.employees.employeeDetails);
    const allEmployee = useSelector(state => state.employees.allEmployees)
    const showDeleteEmployeePopup = useSelector(state => state.employees.showDeleteEmployeePopup);
    const dispatch = useDispatch();
    const { DeleteEmployee } = useEmployeesApi();

    const [ onOpenQrAfterGenerate ]  = useOutletContext();

    const handleDelete = async () => {

        const selectedEmployee = allEmployee.find(employee => employee.name === employeeDetails.EmployeeName);

        const payload = {
            employeeID: selectedEmployee ? selectedEmployee.id : null,
        }
        
        dispatch(setActionType(ACTION_TYPES.DELETE_EMPLOYEE));
        dispatch(setActionPayload(payload))

        dispatch(setShowDeleteEmployeePopup(false));
        dispatch(setShowEmployeeDetailsPopup(false));

        onOpenQrAfterGenerate();
        
    };

    return (
        <Modal className="width-300" centered show={showDeleteEmployeePopup} onHide={() => dispatch(setShowDeleteEmployeePopup(false))}>
            <Modal.Body>
                <div className="delete-modal">
                    <div className='header-modal'>
                        <div className="modal-header-image">
                            <img src={"/Images/warning.png"} alt="warning" />
                        </div>
                        <div className='header-title'>
                            {`Are you sure you want to delete ${employeeDetails.EmployeeName}?`}
                        </div>
                    </div>
                    <div className="response-message mt-3 mb-5">
                        {`By deleting ${employeeDetails.EmployeeName}, they will not be able to access the CashPickup Portal.`}
                    </div>
                    <div>
                        <button
                            id="closeTransferModalBtn"
                            onClick={() => dispatch(setShowDeleteEmployeePopup(false))}
                        >
                            Not Now
                        </button>
                        <button
                            id="closeModalBtn"
                            onClick={handleDelete}
                            style={{ backgroundColor: "#D32127" }}
                        >
                            Delete Employee
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DeleteEmployeePopup;
